import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
const root = createRoot(document.getElementById("root") as HTMLElement);
root.render(<StrictMode data-id="element-106">
    <App data-id="element-107" />
  </StrictMode>);